// useStepNavigation.js
import {ref} from 'vue';
import router from "@/router/router";


/* TODO: Built functionality to keep track of finished steps
    So when a user accesses a step page we can validate if this is correct
    And otherwise redirect to step #1
 */
const curStep = ref(1);
const nextButtonEnabled = ref(false);
const previousButtonEnabled = ref(true);
const nrOfSteps = 4;
const previousButtonText = ref('');
const nextButtonText = ref('');
const previousButtonPressed = ref(false);
const nextButtonPressed = ref(false);

const goToPreviousStep = () => {
    goToStep(curStep.value - 1);
}
const goToNextStep = () => {
    goToStep(curStep.value + 1);
}

const goToStep = (step) => {
    router.push('/step' + step);
}

export default function useStepNavigation() {
    return {
        curStep,
        nrOfSteps,
        previousButtonEnabled,
        previousButtonText,
        previousButtonPressed,
        nextButtonEnabled,
        nextButtonText,
        nextButtonPressed,
        goToPreviousStep,
        goToNextStep,
        goToStep,
    };
}
